/**
 * Changes the window location to begin Oauth service authorization request
 * @return {undefined}
 */
export const authorizeGoogleAccess = () => {
  window.location = "/api/google/request_authorization";
};

export default authorizeGoogleAccess;
